import { React, useState, useRef } from "react";
import axiosInstance from "../../../utils/axiosInstance";

const MarketAnalysisFancy = ({ eventDetails, fancyData, fancyBookData }) => {
  const [showSessionPlPopup, setShowSessionPlPopup] = useState(false);
  const [sessionPLList, setSessionPLList] = useState({});
  const [sessionName, setSessionName] = useState("");
  const [sessionLoading, setSessionLoading] = useState(false);

  const isBetPlace = (fancyBookData, marketid) => {
    let found = false;
    if (fancyBookData == null || fancyBookData == undefined) {
      found = false;
    } else {
      fancyBookData?.find((item) =>
        item.marketid == marketid ? (found = true) : (found = false)
      );
    }
    return found;
  };

  const getColor = (amount) => {
    if (amount < 0) {
      return "red";
    } else {
      return "green";
    }
  };

  const closeSessionPlSlip = () => {
    setShowSessionPlPopup(false);
    setSessionPLList({});
    setSessionLoading(false);
  };

  const showFullBook = async (teamName, sid, evt_id) => {
    setSessionName(teamName);
    setSessionPLList({});
    setSessionLoading(true);
    setShowSessionPlPopup(true);

    try {
      const response = await axiosInstance.post("/games/get-sessionPL", {
        eid: evt_id,
        mid: sid,
        rname: teamName
      });

      if (
        response.data !== null &&
        response.data !== undefined &&
        response.data[0] !== "" &&
        response.data[0] !== null &&
        response.data[0] !== undefined
      ) {
        setSessionPLList(response.data[0]);
      }
    } catch (error) {
      console.error("Error fetching session book:", error);
    } finally {
      setSessionLoading(false);
    }
  };

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  return (
    <div style={{ marginTop: "0px", display: "block" }}>
      <div className="table-box-body">
        <div
          className="card card-accent-danger"
          style={{ marginBottom: "0px" }}
        >
          <div className="row bg-gray-100 market-head">
            <div className="col-12">
              <strong>Fancy</strong>
            </div>
          </div>
        </div>
        <div
          class="market-runners"
          style={{
            borderLeft: "solid 1px #808080",
            borderRight: "solid 1px #808080",
            borderBottom: "solid 1px #808080"
          }}
        >
          <div>
            {fancyData !== null &&
              fancyData !== undefined &&
              fancyData !== "" &&
              fancyData.map((fancy) => (
                <div class="row runners" style={{ backgroundColor: "#fff" }}>
                  <div class="col-7 runner-name">
                    <div>
                      <div style={{ width: "100%" }}>
                        {" "}
                        <strong
                          style={{ fontSize: "1rem" }}
                          className="site_family"
                        >
                          {fancy?.market}
                        </strong>
                      </div>
                      <div style={{ width: "100%" }}>
                        <span
                          style={{
                            display: isBetPlace(fancyBookData, fancy.marketid)
                              ? ""
                              : "none"
                          }}
                        >
                          <span
                            className="site_family"
                            style={{ fontWeight: "bold", color: "red" }}
                          >
                            {formatTruncate(
                              Math.round(
                                (fancyBookData?.find(
                                  (item) => item.marketid == fancy.marketid
                                )?.bak || 0) * -1
                              )
                            )}
                          </span>{" "}
                          <span
                            className="site_family"
                            style={{
                              fontWeight: "bold",
                              paddingLeft: "8px",
                              color: "green"
                            }}
                          >
                            {formatTruncate(
                              Math.round(
                                (fancyBookData?.find(
                                  (item) => item.marketid == fancy.marketid
                                )?.lay || 0) * -1
                              )
                            )}
                          </span>
                        </span>{" "}
                        <span>
                          <a
                            href="#"
                            class="btn btn-link btn-fullBook site_family"
                            /*onClick={(e) => {
                              e.preventDefault();
                              showFullBook(
                                fancy.market,
                                fancy.marketid,
                                fancy.evt_id || eventDetails?.evt_id
                              );
                            }}*/

                            onClick={() => {
                              const width = 400;
                              const height = 450;
                              const left = 0;
                              const top = 0;

                              window.open(
                                `/agent/session-full-book/${fancy.market}/${
                                  fancy.marketid
                                }/${fancy.evt_id || eventDetails?.evt_id}`,
                                "UserBookWindow",
                                `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`
                              );
                            }}
                          >
                            Full Book
                          </a>
                        </span>
                      </div>
                    </div>
                  </div>{" "}
                  <div class="col-5 col-md-8 price">
                    <div
                      class="row"
                      style={{
                        display: fancy?.mid_stat === "OPEN" ? "" : "none"
                      }}
                    >
                      <div class="col-md-2 d-none d-md-block cta-back">
                        <div id="b3-54600" class="col-12 price site_family">
                          {" "}
                        </div>{" "}
                        <div id="bs3-54600" class="col-12 size site_family">
                          {" "}
                        </div>
                      </div>{" "}
                      <div class="col-md-2 d-none d-md-block cta-back">
                        <div
                          id="b2-54600"
                          class="col-md-12 col-sm-12 price site_family"
                        >
                          {" "}
                        </div>{" "}
                        <div
                          id="bs2-54600"
                          class="col-md-12 col-sm-12 size site_family"
                        >
                          {" "}
                        </div>
                      </div>{" "}
                      <div class="col-6 col-md-2 cta-back">
                        <div
                          class="col-12 price site_family"
                          style={{ backgroundColor: "rgb(227, 248, 255)" }}
                        >
                          {fancy.bak}
                        </div>{" "}
                        <div
                          class="col-12 size site_family"
                          style={{ backgroundColor: "rgb(227, 248, 255)" }}
                        >
                          {fancy.bakrate}
                        </div>
                      </div>{" "}
                      <div class="col-6 col-md-2 cta-lay">
                        <div
                          class="col-md-12 col-sm-12 price site_family"
                          style={{ backgroundColor: "rgb(255, 205, 204)" }}
                        >
                          {fancy.lay}
                        </div>{" "}
                        <div
                          class="col-md-12 col-sm-12 size site_family"
                          style={{ backgroundColor: "rgb(255, 205, 204)" }}
                        >
                          {fancy.layrate}
                        </div>
                      </div>{" "}
                      <div class="col-md-2 d-none d-md-block cta-lay">
                        <div
                          id="l2-54600"
                          class="col-md-12 col-sm-12 price site_family"
                        >
                          {" "}
                        </div>{" "}
                        <div
                          id="ls2-54600"
                          class="col-md-12 col-sm-12 size site_family"
                        >
                          {" "}
                        </div>
                      </div>{" "}
                      <div class="col-md-2 d-none d-md-block cta-lay">
                        <div
                          id="l3-54600"
                          class="col-md-12 col-sm-12 price site_family"
                        >
                          {" "}
                        </div>{" "}
                        <div
                          id="ls3-54600"
                          class="col-md-12 col-sm-12 size site_family"
                        >
                          {" "}
                        </div>
                      </div>
                    </div>

                    <div
                      class="row "
                      style={{
                        lineHeight: "51px",
                        color: "red",
                        textAlign: "center",
                        background: "rgb(236, 236, 237)",
                        textTransform: "uppercase",
                        display: fancy?.mid_stat === "OPEN" ? "none" : ""
                      }}
                    >
                      <div
                        style={{ width: "100%", textAlign: "center" }}
                        class="site_family"
                      >
                        {fancy?.mid_stat}{" "}
                      </div>{" "}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>

      {showSessionPlPopup && (
        <div>
          <div className="modal d-block">
            <div className="modal-dialog">
              <div className="modal-content" style={{ width: "99%" }}>
                <div style={{ borderRadius: "6px", background: "white" }}>
                  <table style={{ width: "100%" }}>
                    <tr>
                      <td>
                        <span
                          style={{
                            paddingTop: "13px",
                            paddingLeft: "13px",
                            paddingBottom: "0px",
                            fontSize: "18px",
                            fontWeight: "bold",
                            color: "black"
                          }}
                        >
                          {sessionName}
                        </span>
                      </td>
                      <td style={{ textAlign: "right", paddingRight: "13px" }}>
                        <button
                          type="button"
                          data-dismiss="modal"
                          aria-label="Close"
                          class="close"
                          onClick={() => closeSessionPlSlip()}
                        >
                          <span aria-hidden="true">×</span>
                        </button>
                      </td>
                    </tr>
                  </table>

                  <div
                    className="modal-body"
                    style={{ height: "500px", overflowX: "auto" }}
                  >
                    {sessionLoading ? (
                      <div style={{ color: "black", padding: "13px" }}>
                        Please wait Loading....
                      </div>
                    ) : (
                      <table className="table">
                        <tbody>
                          <tr>
                            <th style={{ color: "black" }}>Score</th>
                            <th style={{ color: "black" }}>Position</th>
                          </tr>
                          {Object.keys(sessionPLList)
                            .sort((a, b) => Number(a) - Number(b))
                            .map((key) => (
                              <tr key={key}>
                                <td style={{ color: "black" }}>{key}</td>
                                <td
                                  style={{
                                    color: getColor(sessionPLList[key])
                                  }}
                                >
                                  {sessionPLList[key]}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MarketAnalysisFancy;
